import React from "react";

const NinjaBotFeature = ({ stepNumber = 6, onTryNinjaBotClick }) => {
  return (
    <div className="backdrop-blur-sm bg-[#406AFF]/5 flex flex-col items-center justify-center pb-6 pt-0 px-3 relative rounded-xl w-full shadow-[0px_-4px_20px_0px_rgba(0,0,0,0.3)]" style={{boxShadow: '0 -4px 20px 0 rgba(0, 0, 0, 0.3);'}}>
        <img alt="" className="w-full -mt-5 h-[50px]" src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Ellipse%201270.png"/>

      {/* Main content container */}
      <div className="flex flex-col gap-4 items-center relative w-full">
        {/* Header section with step number and title */}
        <div className="flex flex-col gap-3 items-center relative w-full">
          {/* Step number badge */}
          <div className="border-[#c1dcff] border-[1.5px] border-solid flex items-center justify-center p-[10px] relative rounded-[24px] w-6 h-6">
            <p 
              className="font-bold text-[14px] leading-none tracking-[-0.14px] font-['Inter']"
              style={{
                background: "linear-gradient(180deg, #c1dcff 0%, #406aff 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}
            >
              {stepNumber}
            </p>
          </div>

          {/* Title and description */}
          <div className="flex flex-col gap-[6px] items-center w-full">
            <h2 
              className="font-bold text-[16px] leading-none tracking-[-0.16px] text-center font-['Inter']"
              style={{
                background: "linear-gradient(90deg, rgba(193, 220, 255, 1) 0%, rgba(13, 91, 249, 1) 117.87%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}
            >
              24/7 Doubt & Interview Feedback
            </h2>
            
            <p className="font-normal text-[12px] leading-[1.4] text-center text-[rgba(255,255,255,0.7)] font-['Inter'] whitespace-pre-wrap max-w-full">
              Get unlimited doubt solving and live interview feedback anytime with Ninja bot
            </p>
          </div>
        </div>

        {/* CTA section with button and mobile mockup */}
        <div className="flex gap-4 items-center justify-center relative">
          {/* Try NinjaBot button */}
          <button
            onClick={onTryNinjaBotClick}
            className="bg-[#406aff] flex gap-[6px] items-center justify-center px-3 py-2 relative rounded-[24px] transition-all hover:bg-[#3759e6] active:scale-95"
          >
            <span className="font-semibold text-[12px] leading-[1.3] text-center text-white font-['Inter'] whitespace-nowrap">
              Try NinjaBot Now
            </span>
            
            {/* Arrow icon */}
            <div className="flex h-3 items-center justify-center relative w-[14px]">
              <svg
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="rotate-90"
              >
                <path
                  d="M6.75 13L6.75 2.5L10.5 6.25L11.25 5.5L6 0.25L0.75 5.5L1.5 6.25L5.25 2.5L5.25 13L6.75 13Z"
                  fill="white"
                />
              </svg>
            </div>
          </button>

          <img alt="" src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Stats/image%20884.png" className="w-[30%]"/>
        </div>
      </div>
    </div>
  );
};

export default NinjaBotFeature;
